import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    gridGap: theme.spacing(2),
  },
}));
